export default "__VITE_ASSET__CaBCopiG__"